import Modal from "@components/Modal";
import { useModal } from "@components/Modal/ModalProvider";
import { useCallback, useEffect, useRef } from "react";
import DicomTagModalContent from "./DicomTagModalContent";

export function useDicomTagModal(){
  const { openModal, closeModal } = useModal();
  const modalIdRef = useRef<string | null>(null);

  const closeWithFlagOff = useCallback(() => {
    closeModal(modalIdRef.current as string)
    modalIdRef.current = null
  },[modalIdRef]);

  const dicomTagModalOpen = useCallback(() => {
    if(modalIdRef.current) return;
    modalIdRef.current = openModal(
      <Modal
        type='page'
        close={() => closeWithFlagOff()}
        description={<DicomTagModalContent close={() => closeWithFlagOff()}/>}
      />,
      false,
      () => closeWithFlagOff()
    );
  }, [modalIdRef])

  useEffect(() => {
    if (modalIdRef.current) {
      closeWithFlagOff();
    }
  }, []);

  return dicomTagModalOpen;
}
